//export const USER_SIGNUP = process.env.REACT_APP_API_URL + '/common/user/signup/'
export const USER_SIGNUP = '/users/signup/'
export const USER_LOGIN = '/users/login/'
export const REQUEST_2FA_CODE = (channel) => `/users/request-2fa-code/${channel}/`
export const USER_LOGOUT = '/users/logout/'
export const EMAIL_DOMAIN_CHECK = '/users/email-is-valid/'
export const RESET_PHONE_NUMBER = '/users/phone-number/'
export const GEO = 'https://ipapi.co/json/'
